import React from 'react';
import styled from 'styled-components';

import Imgix from 'shared/components/imgix';
import { Preview, PreviewProps } from '../preview';
import { NavBar } from '../navbar';

type CollectionsPageProps = Omit<PreviewProps, 'children'> & { title: string; description: string; image: string };

const imgixParams = {
  h: 296,
  w: 1940,
  fit: 'crop',
};

export function CollectionsPage({ data, title, description, image }: CollectionsPageProps): JSX.Element {
  return (
    <Preview data={data}>
      <NavBar />

      <Content>
        <Title>{title}</Title>
        <Description>{description}</Description>

        {image && (
          <ImageWrapper>
            <Image src={image} imgixParams={imgixParams} htmlAttributes={{ alt: '' }} disableSrcSet />
          </ImageWrapper>
        )}

        <MoreInfo>Selected Products will appear below here...</MoreInfo>
      </Content>
    </Preview>
  );
}

const Content = styled.div`
  padding: 24px;
  text-align: left;
`;

const Title = styled.h1`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #242526;
  margin-bottom: 12px;
`;

const Description = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 23px;
  color: #4b5257;
`;

const ImageWrapper = styled.div`
  height: 148px;
  margin-top: 12px;
  max-width: 970px;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const Image = styled(Imgix)<{ src: string; imgixParams: any; htmlAttributes: any; disableSrcSet: boolean }>`
  display: block;
  height: 100%;
  left: 50%;
  max-width: none;
  position: absolute;
  top: 0;
  transform: translateX(-50%);
`;

const MoreInfo = styled.div`
  max-width: 160px;
  text-align: center;
  margin: 40px auto;
  font-size: 13px;
  line-height: 21px;
  color: #caced4;
`;
